module.exports = __webpack_public_path__ + "static/img/szafa_15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_15.jpg
// module id = UUme
// module chunks = 0